module.exports = "/static/assets/f6af8ce94d2a2019c213cf2c0df908b4.png";